/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.125.1-v202606250147-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise } from 'axios';
import { getAxiosInstance, SeeqAxiosRequestConfig } from '@/requests/axios.utilities';
import { isNil, omitBy } from 'lodash';
import * as qs from 'qs';
import * as models from '../model/models';
import { APPSERVER_API_PREFIX } from '@/main/app.constants';

export class sqContextApiClass {
 
   constructor() {}

  /**
   * @summary Archive multiple context labels
   * @param {string} itemId - ID of the item that the labels are associated with
  */
  public batchArchiveContextLabels(
    body: models.BatchArchiveContextLabelsInputV1,
    {
      itemId
    } : {
      itemId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(itemId)) {
      throw new Error("'itemId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/${encodeURIComponent(String(itemId))}/labels/batch/archive`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise;
  }

  /**
   * @summary Create or update multiple labels
   * @param {string} itemId - ID of the item that the labels are associated with
  */
  public batchCreateContextLabels(
    body: Array<models.ContextLabelWithIdInputV1>,
    {
      itemId
    } : {
      itemId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(itemId)) {
      throw new Error("'itemId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/${encodeURIComponent(String(itemId))}/labels/batch`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<Array<models.ContextLabelOutputV1>>;
  }

  /**
   * @summary Create a new comment category
  */
  public createCommentCategory(
    body: models.CommentCategoryInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/comments/categories`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.CommentCategoryOutputV1>;
  }

  /**
   * @summary Create a new comment associated with an Item
   * @param {string} itemId - ID of the item that the comment is associated with
  */
  public createContextComment(
    body: models.ContextCommentInputV1,
    {
      itemId
    } : {
      itemId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(itemId)) {
      throw new Error("'itemId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/${encodeURIComponent(String(itemId))}/comments`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ContextCommentOutputV1>;
  }

  /**
   * @summary Create a new label associated with an item
   * @param {string} itemId - ID of the item that the label is associated with
  */
  public createContextLabel(
    body: models.ContextLabelInputV1,
    {
      itemId
    } : {
      itemId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(itemId)) {
      throw new Error("'itemId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/${encodeURIComponent(String(itemId))}/labels`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ContextLabelOutputV1>;
  }

  /**
   * @summary Create a new numeric context associated with an item
   * @param {string} itemId - ID of the item that the numeric context is associated with
  */
  public createContextNumeric(
    body: models.ContextNumericInputV1,
    {
      itemId
    } : {
      itemId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(itemId)) {
      throw new Error("'itemId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/${encodeURIComponent(String(itemId))}/numeric`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ContextNumericOutputV1>;
  }

  /**
   * @summary Create new opaque context associated with an item
   * @param {string} itemId - ID of the item that the opaque context is associated with
  */
  public createContextOpaque(
    body: models.ContextOpaqueInputV1,
    {
      itemId
    } : {
      itemId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(itemId)) {
      throw new Error("'itemId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/${encodeURIComponent(String(itemId))}/opaque`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ContextOpaqueOutputV1>;
  }

  /**
   * @summary Create a new label
  */
  public createLabel(
    body: models.LabelInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/labels`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.LabelOutputV1>;
  }

  /**
   * @summary Create a new label category
  */
  public createLabelCategory(
    body: models.LabelCategoryInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/labels/categories`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.LabelCategoryOutputV1>;
  }

  /**
   * @summary Create a new numeric description
  */
  public createNumericDescription(
    body: models.NumericDescriptionInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/numeric`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.NumericDescriptionOutputV1>;
  }

  /**
   * @summary Delete a comment category
   * @param {string} id
  */
  public deleteCommentCategory(
    {
      id
    } : {
      id: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(id)) {
      throw new Error("'id' parameter required");
    }

    return getAxiosInstance()({
      method: 'delete',
      url: APPSERVER_API_PREFIX + `/context/comments/categories/${encodeURIComponent(String(id))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise;
  }

  /**
   * @summary Delete or archive a comment
   * @param {string} itemId - ID of the item that the comment is associated with
   * @param {string} commentId - The comment ID to be deleted
   * @param {boolean} [_delete=false] - Permanently and irretrievably delete the comment
  */
  public deleteContextComment(
    {
      itemId,
      commentId,
      _delete
    } : {
      itemId: string,
      commentId: string,
      _delete?: boolean
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(itemId)) {
      throw new Error("'itemId' parameter required");
    }

    if (isNil(commentId)) {
      throw new Error("'commentId' parameter required");
    }

    return getAxiosInstance()({
      method: 'delete',
      url: APPSERVER_API_PREFIX + `/context/${encodeURIComponent(String(itemId))}/comments/${encodeURIComponent(String(commentId))}`,

      params: omitBy({
        ['delete']: _delete
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Archive a label
   * @param {string} itemId - ID of the item that the label is associated with
   * @param {string} labelId - The context label ID to be archived
   * @param {string} [tableId] - If provided, the ID of the Table Definition that will be used for permissions checking. The user needs read permissions on the provided table definition and theitem has to be in the table in order to create, update, or delete context. If not provided, the user must have read permissions on the item id the context is being applied to.
   * @param {boolean} [archiveChildren] - If true, child labels and all of their descendants will also be archived.
  */
  public deleteContextLabel(
    {
      itemId,
      labelId,
      tableId,
      archiveChildren
    } : {
      itemId: string,
      labelId: string,
      tableId?: string,
      archiveChildren?: boolean
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(itemId)) {
      throw new Error("'itemId' parameter required");
    }

    if (isNil(labelId)) {
      throw new Error("'labelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'delete',
      url: APPSERVER_API_PREFIX + `/context/${encodeURIComponent(String(itemId))}/labels/${encodeURIComponent(String(labelId))}`,

      params: omitBy({
        ['tableId']: tableId,
        ['archiveChildren']: archiveChildren
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Delete or archive a numeric context
   * @param {string} itemId - ID of the item that the numeric context is associated with
   * @param {string} numericContextId - The context numeric ID to be deleted
   * @param {string} [tableId] - If provided, the ID of the Table Definition that will be used for permissions checking. The user needs read permissions on the provided table definition and theitem has to be in the table in order to create, update, or delete context. If not provided, the user must have read permissions on the item id the context is being applied to.
   * @param {boolean} [_delete] - Permanently and irretrievably delete the numeric context
  */
  public deleteContextNumeric(
    {
      itemId,
      numericContextId,
      tableId,
      _delete
    } : {
      itemId: string,
      numericContextId: string,
      tableId?: string,
      _delete?: boolean
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(itemId)) {
      throw new Error("'itemId' parameter required");
    }

    if (isNil(numericContextId)) {
      throw new Error("'numericContextId' parameter required");
    }

    return getAxiosInstance()({
      method: 'delete',
      url: APPSERVER_API_PREFIX + `/context/${encodeURIComponent(String(itemId))}/numeric/${encodeURIComponent(String(numericContextId))}`,

      params: omitBy({
        ['tableId']: tableId,
        ['delete']: _delete
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Delete or archive opaque context
   * @param {string} itemId - ID of the item that the opaque context is associated with
   * @param {string} opaqueId - The opaque ID to be deleted
   * @param {boolean} [_delete=false] - Permanently and irretrievably delete the opaque context
   * @param {string} [tableId] - If provided, the ID of the Table Definition that will be used for permissions checking. The user needs read permissions on the provided table definition and theitem has to be in the table in order to create, update, or delete context. If not provided, the user must have read permissions on the item id the context is being applied to.
  */
  public deleteContextOpaque(
    {
      itemId,
      opaqueId,
      _delete,
      tableId
    } : {
      itemId: string,
      opaqueId: string,
      _delete?: boolean,
      tableId?: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(itemId)) {
      throw new Error("'itemId' parameter required");
    }

    if (isNil(opaqueId)) {
      throw new Error("'opaqueId' parameter required");
    }

    return getAxiosInstance()({
      method: 'delete',
      url: APPSERVER_API_PREFIX + `/context/${encodeURIComponent(String(itemId))}/opaque/${encodeURIComponent(String(opaqueId))}`,

      params: omitBy({
        ['delete']: _delete,
        ['tableId']: tableId
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Delete or archive a specific label.
   * @param {string} labelId - ID of the label
   * @param {boolean} [_delete] - Permanently and irretrievably delete the category
  */
  public deleteLabel(
    {
      labelId,
      _delete
    } : {
      labelId: string,
      _delete?: boolean
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(labelId)) {
      throw new Error("'labelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'delete',
      url: APPSERVER_API_PREFIX + `/context/labels/${encodeURIComponent(String(labelId))}`,

      params: omitBy({
        ['delete']: _delete
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Delete or archive a specific label category.
   * @param {string} categoryId - ID of the category
   * @param {boolean} [_delete=false] - Permanently and irretrievably delete the category
  */
  public deleteLabelCategory(
    {
      categoryId,
      _delete
    } : {
      categoryId: string,
      _delete?: boolean
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(categoryId)) {
      throw new Error("'categoryId' parameter required");
    }

    return getAxiosInstance()({
      method: 'delete',
      url: APPSERVER_API_PREFIX + `/context/labels/categories/${encodeURIComponent(String(categoryId))}`,

      params: omitBy({
        ['delete']: _delete
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Delete a numeric description
   * @param {string} id
  */
  public deleteNumericDescription(
    {
      id
    } : {
      id: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(id)) {
      throw new Error("'id' parameter required");
    }

    return getAxiosInstance()({
      method: 'delete',
      url: APPSERVER_API_PREFIX + `/context/numeric/${encodeURIComponent(String(id))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise;
  }

  /**
   * @summary Get all label categories
   * @param {string} [parentId] - If set to the ID of a parent category then the child categories will be returned; if set to the empty GUID (00000000-0000-0000-0000-000000000000) only top level categories will be returned; if not specified all categories will be returned
   * @param {boolean} [includeArchived] - If set to true, archived categories will be included in the results. Default is false.
  */
  public findLabelCategories(
    {
      parentId,
      includeArchived
    } : {
      parentId?: string,
      includeArchived?: boolean
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/context/labels/categories`,

      params: omitBy({
        ['parentId']: parentId,
        ['includeArchived']: includeArchived
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.LabelCategoryOutputListV1>;
  }

  /**
   * @summary Get all labels for a given category
   * @param {string} categoryId - ID of the category of labels to return
   * @param {string} [query] - Search for labels that contain this string in a case-insensitive manner. This is especially useful for autocomplete categories. Note that if this is specified only the first 20 results will be returned, ordered by name
   * @param {string} [parentId] - If set to the ID of a parent label then the child labels will be returned; if set to the empty GUID (00000000-0000-0000-0000-000000000000) only top level labels will be returned; if not specified all labels will be returned
   * @param {boolean} [includeArchived] - If set to true, archived labels will be included in the results. Default is false.
  */
  public findLabels(
    {
      categoryId,
      query,
      parentId,
      includeArchived
    } : {
      categoryId: string,
      query?: string,
      parentId?: string,
      includeArchived?: boolean
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(categoryId)) {
      throw new Error("'categoryId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/context/labels/${encodeURIComponent(String(categoryId))}`,

      params: omitBy({
        ['query']: query,
        ['parentId']: parentId,
        ['includeArchived']: includeArchived
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.LabelOutputListV1>;
  }

  /**
   * @summary Get all comment categories
  */
  public getAllCommentCategories(
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/context/comments/categories`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.CommentCategoryOutputListV1>;
  }

  /**
   * @summary Fetch all context types for specified item IDs
  */
  public getAllContext(
    body: models.GetAllContextInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/search/all`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.AllContextOutputV1>;
  }

  /**
   * @summary Get all numeric descriptions
  */
  public getAllNumericDescriptions(
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/context/numeric/descriptions`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.NumericDescriptionOutputListV1>;
  }

  /**
   * @summary Get comment category by ID
   * @param {string} id
  */
  public getCommentCategory(
    {
      id
    } : {
      id: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(id)) {
      throw new Error("'id' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/context/comments/categories/${encodeURIComponent(String(id))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.CommentCategoryOutputV1>;
  }

  /**
   * @summary Fetch context comments for specified item IDs
  */
  public getContextComments(
    body: models.GetContextInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/search/comments`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ContextCommentListOutputV1>;
  }

  /**
   * @summary Fetch context conditions for specified item IDs
  */
  public getContextConditions(
    body: models.GetContextConditionInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/conditions`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ContextConditionOutputListV1>;
  }

  /**
   * @summary Fetch context labels for specified item IDs
  */
  public getContextLabels(
    body: models.GetContextInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/search/labels`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ContextLabelListOutputV1>;
  }

  /**
   * @summary Fetch numeric context for specified item IDs
  */
  public getContextNumerics(
    body: models.GetContextInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/search/numerics`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ContextNumericListOutputV1>;
  }

  /**
   * @summary Fetch opaque context for specified item IDs
  */
  public getContextOpaque(
    body: models.GetContextInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/search/opaque`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ContextOpaqueListOutputV1>;
  }

  /**
   * @summary Get label hierarchies for given category/label pairs. If no potential match for a given pair exists, nothing is returned for that pair.
  */
  public getLabelHierarchies(
    body: models.LabelHierarchyInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/labels/hierarchies`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.LabelHierarchyOutputListV1>;
  }

  /**
   * @summary Gets all items associated with the given label ID
   * @param {string} labelId - The ID of the label
   * @param {number} [limit] - The pagination limit, the total number of collection items that will be returned in this page of results.
   * @param {number} [offset] - The pagination offset, the index of the first collection item that will be returned in this page of results.
   * @param {boolean} [includeArchivedContext] - If true, items associated via archived context label associations will be included in the results. Defaults to false.
   * @param {boolean} [includeArchivedItems] - If true, archived items will be included in the results. Defaults to false.
  */
  public getLabeledItems(
    {
      labelId,
      limit,
      offset,
      includeArchivedContext,
      includeArchivedItems
    } : {
      labelId: string,
      limit?: number,
      offset?: number,
      includeArchivedContext?: boolean,
      includeArchivedItems?: boolean
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(labelId)) {
      throw new Error("'labelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/context/${encodeURIComponent(String(labelId))}/labels/items`,

      params: omitBy({
        ['limit']: limit,
        ['offset']: offset,
        ['includeArchivedContext']: includeArchivedContext,
        ['includeArchivedItems']: includeArchivedItems
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ItemPreviewListV1>;
  }

  /**
   * @summary Get numeric description. This method is deprecated.
   * @param {string} [id]
   * @deprecated Use /{id} path parameter instead of query parameter
  */
  public getNumericDescription(
    {
      id
    } : {
      id?: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/context/numeric`,

      params: omitBy({
        ['id']: id
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.NumericDescriptionOutputV1>;
  }

  /**
   * @summary Get numeric description by ID
   * @param {string} id
  */
  public getNumericDescriptionWithPathId(
    {
      id
    } : {
      id: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(id)) {
      throw new Error("'id' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/context/numeric/${encodeURIComponent(String(id))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.NumericDescriptionOutputV1>;
  }

  /**
   * @summary Search for context comments using string fragments and filters. This search is fast but eventually consistent, so recent writes may take time to appear. Results are filtered by read access to the parent items of the comments.
   * @param {string} [query] - String fragment to search for. Text is matched against comment content. If query is not supplied, all comments are returned.
   * @param {string} [sortField] - Field to sort by. Supported values are CreatedAt and UpdatedAt. Leave empty to use the default relevance sorting.
   * @param {string} [sortOrder=DESC] - Sort order for the results. Supported values are ASC and DESC.
   * @param {number} [hitsPerPage=40] - Number of hits to return per page. Defaults to 40.
   * @param {number} [page=1] - One-based page number to retrieve. If zero is specified, no hits are returned and only the hit counts are returned.
   * @param {string} [hitHighlightFormat] - If supplied, enables hit highlighting for matched words in the content. The value must contain a &#x27;%s&#x27; placeholder, for example an HTML tag wrapped around &#x27;%s&#x27;. If not specified, hit highlighting is disabled.
  */
  public searchContextComments(
    {
      query,
      sortField,
      sortOrder,
      hitsPerPage,
      page,
      hitHighlightFormat
    } : {
      query?: string,
      sortField?: SortFieldEnum,
      sortOrder?: SortOrderEnum,
      hitsPerPage?: number,
      page?: number,
      hitHighlightFormat?: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/context/search`,

      params: omitBy({
        ['query']: query,
        ['sortField']: sortField,
        ['sortOrder']: sortOrder,
        ['hitsPerPage']: hitsPerPage,
        ['page']: page,
        ['hitHighlightFormat']: hitHighlightFormat
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ContextCommentSearchResultsV1>;
  }

  /**
   * @summary Update a comment category
   * @param {string} id
  */
  public updateCommentCategory(
    body: models.CommentCategoryInputV1,
    {
      id
    } : {
      id: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(id)) {
      throw new Error("'id' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/comments/categories/${encodeURIComponent(String(id))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.CommentCategoryOutputV1>;
  }

  /**
   * @summary Update a comment
   * @param {string} itemId - ID of the item that the comment is associated with
   * @param {string} commentId - ID of the comment to update
  */
  public updateContextComment(
    body: models.ContextCommentInputV1,
    {
      itemId,
      commentId
    } : {
      itemId: string,
      commentId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(itemId)) {
      throw new Error("'itemId' parameter required");
    }

    if (isNil(commentId)) {
      throw new Error("'commentId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/${encodeURIComponent(String(itemId))}/comments/${encodeURIComponent(String(commentId))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ContextCommentOutputV1>;
  }

  /**
   * @summary Update a numeric context
   * @param {string} itemId - ID of the item that the numeric context is associated with
   * @param {string} numericContextId - ID of the numeric context to update
  */
  public updateContextNumeric(
    body: models.ContextNumericInputV1,
    {
      itemId,
      numericContextId
    } : {
      itemId: string,
      numericContextId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(itemId)) {
      throw new Error("'itemId' parameter required");
    }

    if (isNil(numericContextId)) {
      throw new Error("'numericContextId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/${encodeURIComponent(String(itemId))}/numeric/${encodeURIComponent(String(numericContextId))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ContextNumericOutputV1>;
  }

  /**
   * @summary Update opaque context
   * @param {string} itemId - ID of the item that the opaque context is associated with
   * @param {string} opaqueId - ID of the opaque context to update
  */
  public updateContextOpaque(
    body: models.ContextOpaqueInputV1,
    {
      itemId,
      opaqueId
    } : {
      itemId: string,
      opaqueId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(itemId)) {
      throw new Error("'itemId' parameter required");
    }

    if (isNil(opaqueId)) {
      throw new Error("'opaqueId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/${encodeURIComponent(String(itemId))}/opaque/${encodeURIComponent(String(opaqueId))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ContextOpaqueOutputV1>;
  }

  /**
   * @summary Update a label
   * @param {string} labelId
  */
  public updateLabel(
    body: models.LabelInputV1,
    {
      labelId
    } : {
      labelId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(labelId)) {
      throw new Error("'labelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/labels/${encodeURIComponent(String(labelId))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.LabelOutputV1>;
  }

  /**
   * @summary Update a label category
   * @param {string} categoryId
  */
  public updateLabelCategory(
    body: models.LabelCategoryInputV1,
    {
      categoryId
    } : {
      categoryId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(categoryId)) {
      throw new Error("'categoryId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/labels/categories/${encodeURIComponent(String(categoryId))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.LabelCategoryOutputV1>;
  }

  /**
   * @summary Update a numeric description
   * @param {string} id
  */
  public updateNumericDescription(
    body: models.NumericDescriptionInputV1,
    {
      id
    } : {
      id: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(id)) {
      throw new Error("'id' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/context/numeric/${encodeURIComponent(String(id))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ContextNumericOutputV1>;
  }

}

export enum SortFieldEnum {
    CreatedAt = 'CreatedAt',
    UpdatedAt = 'UpdatedAt'
}
export enum SortOrderEnum {
    ASC = 'ASC',
    DESC = 'DESC'
}

export const sqContextApi = new sqContextApiClass();
